import { render, staticRenderFns } from "./loseRecovery.vue?vue&type=template&id=fce7db64&scoped=true"
import script from "./loseRecovery.vue?vue&type=script&lang=js"
export * from "./loseRecovery.vue?vue&type=script&lang=js"
import style0 from "./loseRecovery.vue?vue&type=style&index=0&id=fce7db64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce7db64",
  null
  
)

export default component.exports